import React from "react";
import { StatusBadgeProps } from "../../../types";
import "./StatusBadge.css";

const StatusBadge: React.FC<StatusBadgeProps> = ({
  children,
  variant = "primary",
  className = "",
  style,
  ...props
}) => {
  return (
    <span className={`status-badge badge-${variant} ${className}`} style={style} {...props}>
      {children}
    </span>
  );
};

export default StatusBadge;
